<template>
	<div>
		<template v-if="button">
			<div  id='CameraCtl' style="width:600px; height: 400px;position: fixed;right: 200%;bottom: 0;"> </div>
			<Button :loading="loading" @click="gather">{{$t('gather')}}</Button>
		</template>
		<div v-else>
			<div style="display: flex;justify-content: center;">
				<div  id='CameraCtl' style="width:600px; height: 400px">  </div>
				<div style="margin-left: 10px;max-width: width: 198px;">
					拍照图片
					<br />
					<img v-if="fileInfo.url" :src="fileInfo.url" style="width: 198px;height: 198px;">
					<div v-if="fileInfo.url" style="text-align: center;margin-top: 10px;">{{fileInfo.path}}</div>
				</div>
			</div>
			<div style="margin-top: 10px;display: flex;flex-wrap: wrap;">
				<div v-for="field in fields" :key="field.key" style="margin-right: 10px;margin-bottom: 10px">
					<div style="margin-bottom: 10px;">{{field.name}}</div>
					<Input :placeholder="field.placeholder" v-model="formData[field.key]" @on-enter="handlerMethod(field)" v-if="field.input" style="width: 200px"></Input>
					<Select v-else @on-change="handlerMethod(field)" v-model="formData[field.key]" style="width:200px">
							<Option v-for="item in options[field.key+'s']" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
				</div>
			</div>
			<div style="margin-top: 10px;">
				<Button style="margin-right: 10px;margin-bottom: 10px;" v-for="field in btnFields" :key="field.name" @click="()=>field.click && field.click()">{{field.name}}</Button>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		inject:['$page'],
		props: {
			params: {
				type: Object,
				default: ()=>({})
			},
			close: {
				type: Function,
				default: ()=>{}
			},
			button:{
				type: Boolean,
				default:false
			}
		},
		data() {
			return {
				isInit:false,
				loading:false,
				current:0,
				formData:{
					resolution:'',
					devName:'',
					fileType:0,
					quality:60,
					dpi:200,
					cutMode:0,
					colorModel:0,
					path:'KHFiles\\',
					drive:'',
				},
				fileInfo:{
					url:'',
					name:'',
				},
				options:{
					drives:[],
					resolutions:[],
					devNames:[],
					fileTypes:[
						{value:0,label:'jpg'},
						{value:1,label:'png'},
						{value:2,label:'tif'},
						{value:3,label:'pdf'}
					],
					qualitys:Array(10).fill(1).map((_,i)=>({label:i*10+10,value:i*10+10})),
					dpis:Array(6).fill(1).map((_,i)=>({label:i*100+100,value:i*100+100})),
					cutModes:[
						{value:0,label:'不裁切'},
						{value:2,label:'手动裁切'},
						{value:1,label:'自动裁切'},
						{value:3,label:'自定义'}
					],
					colorModels:[
						{value:0,label:'彩色'},
						{value:2,label:'灰度'},
						{value:1,label:'黑白'},
					],
				},
				fields:[
					{
						key:'devName',
						name:'设备',
						click:({value})=>{
							this.options.devNames.find((t,i)=>{
								if(t === value){
									this.current = i
									return true
								}
							})
							Cam_GetDevResolution(this.current);
						},
					},
					{
						key:'resolution',
						name:'分辨率',
						click:({value})=>{
							let data = value.split('*')
							Cam_Open(this.current, data[0], data[1]);
						},
					},
					// {
					// 	key:'cutMode',
					// 	name:'裁切模式',
					// 	click:({value})=>{
					// 		console.log('change',value);
					// 		Cam_SetCutMode(value);
					// 		if(value == 3)SetCustomArea(3000,3000,9000,9000);
					// 	}
					// },
					{
						key:'fileType',
						name:'文件格式',
						click:({value})=>{
							Cam_SetFileType(value);
						}
					},
					{
						key:'colorModel',
						name:'色彩模式',
						click:({value})=>{
							Cam_SetColorMode(value);
						}
					},
					{
						key:'quality',
						name:'图像质量',
						click:(value)=>{
							Cam_SetJpgQuality(value);
						}
					},
					{
						key:'dpi',
						name:'DPI',
						click:({value})=>{
							SetDpi(value, value);
						}
					},
					{
						key:'drive',
						name:'盘符',
						click:({value})=>{
							SetDpi(value, value);
						}
					},
					{
						key:'path',
						name:'存储位置',
						input:true,
						placeholder:'\\',
						click:({value})=>{
							console.log(value);
						}
					}
				],
				btnFields:[
					{
						name:'打开设备',
						click:()=>{
							let data = this.formData.resolution.split('*')
							Cam_Open(this.current, data[0], data[1]);
						}
					},
					{
						name:'关闭设备',
						click:()=>Cam_Close(),
					},
					{
						name:'拍照',
						click:()=>{
							this.TakePhoto()
						}
					},
					{
						name:'上传',
						click:()=>{
							this.params.callback({
								file:this.dataURLtoBlob(this.fileInfo.url,this.fileInfo.name),
								name:this.fileInfo.name
							})
							if(this.params.multiple){
								this.$page.toast(this.$t('Start uploading'))
							}else{
								this.close()
							}
						}
					},
					{
						name:'放大',
						click:()=>Cam_ZoomIn(),
					},
					{
						name:'缩小',
						click:()=>Cam_ZoomOut(),
					},
					{
						name:'适屏',
						click:()=>Cam_BestSize(),
					},
					{
						name:'1:1',
						click:()=>Cam_TrueSize(),
					},
					{
						name:'左旋',
						click:()=>Cam_RotateLeft(),
					},
					{
						name:'右旋',
						click:()=>Cam_RotateRight(),
					},
					{
						name:'对焦',
						click:()=>Cam_Focus(),
					},
					{
						name:'设置',
						click:()=>Cam_ShowVideoProp(),
					},
				]
			}
		},
		mounted() {
			let that = this;
			if(!this.button){
				this.init()
			}
			reFun('GetDevCountAndNameResultCB',function(devCount, devNameArr){
				that.options.devNames = devNameArr.map(t=>({label:t,value:t})),Cam_GetDevResolution(that.current);
				that.formData.devName = devNameArr[0]
				GetDrives()
			})
			reFun('GetResolutionResultCB',function(resCount, resArr){
				if (resCount > 0) {
				    that.options.resolutions = resArr.map(t=>{
							if(t == '2592*1944')that.formData.resolution = t
							return ({value:t,label:t})
						})
						if(!that.formData.resolution)that.formData.resolution = resArr[0]
				    Cam_Close();
				    that.sleep(100);
				    var restr = that.formData.resolution;
				    var pos = restr.lastIndexOf("*");
				    var width = parseInt(restr.substring(0, pos));
				    var height = parseInt(restr.substring(pos + 1, restr.length));
				    Cam_Open(that.current, width, height);
				}else {
					that.loading = false;
					that.$page.toast("设备开启失败！",'error');
				}
			})
			reFun('GetCaptrueImgResultCB',function(flag, path , base64Str){
				console.log('触发拍照');
				if (flag == 0) {
					that.fileInfo.url = "data:;base64," + base64Str;
					that.loading = false
					if(that.button){
						that.confirm()
					}
				}
				else that.$page.toast("拍照失败!",'error');
			})
			reFun('GetCameraOnOffStatus',function(status){
				that.isInit = true;
				if (status != 0){
					that.loading = false;
					that.$page.toast("设备开启失败!",'error');
				}
				else {
					if(that.button){
						setTimeout(function() {
							that.TakePhoto()
						}, 2000);
					}
				}
			})
			reFun('GetDriveResultCB',function(driveStr){
				if (driveStr == '') that.$page.toast("获取盘符失败!",'error');
				else{
					that.options.drives = driveStr.split('\\').filter(t=>t).map(t=>{
						return {
							label:t+'\\',
							value:t+'\\'
						}
					})
					let drives = that.options.drives[1] || that.options.drives[0]
					that.formData.drive = drives.value
				}
				
			})
		},
		methods:{
			gather(){
				this.loading = true
				if(this.isInit){
					let data = this.formData.resolution.split('*')
					Cam_Open(this.current, data[0], data[1]);
					this.TakePhoto()
				}else this.init()
			},
			confirm(){
				if(this.button){
					console.log('触发完成');
					return this.$emit('confirm',{
						file:this.dataURLtoBlob(this.fileInfo.url,this.fileInfo.name),
						name:this.fileInfo.name
					})
				}
				this.params.callback({
					file:this.dataURLtoBlob(this.fileInfo.url,this.fileInfo.name),
					name:this.fileInfo.name
				})
				if(this.params.multiple){
					this.$page.toast(this.$t('Start uploading'))
				}else{
					this.close()
				}
			},
			cancel(){
				if(socket){
					Cam_Close()
					socket.close();
					clearInterval(intervalId);
					isSocketConnect = false
					socket = null;
				}
				
			},
			handlerMethod(field){
				if(field.click){
					field.click({value:this.formData[field.key],field})
				}
			},
			sleep(milliSeconds) {
			    var startTime = new Date().getTime();
			    while (new Date().getTime() < startTime + milliSeconds);
			},
			init(){
				if (!window.WebSocket) {
				    alert("浏览器不支持HTML5,请更新浏览器或者使用其它浏览器");
				}
				//console.log("LoadCameraDocument");
				var obj = document.getElementById("CameraCtl");
				Cam_ControlInit(obj,0, 0, 600, 400);
			},
			toOpenCamera() {
				var CamID = document.getElementById("DevName").selectedIndex;
				var obj = document.getElementById("DevResolution");
				var restr = obj[obj.selectedIndex].text;
				var pos = restr.lastIndexOf("*");
				var width = parseInt(restr.substring(0, pos));
				var height = parseInt(restr.substring(pos + 1, restr.length));
				Cam_Open(CamID, width, height);
			},
			dataURLtoBlob(dataurl, name) {
				 var arr = dataurl.split(","),
				 mime = arr[0].match(/:(.*?);/)[1],
				 bstr = atob(arr[1]),
				 n = bstr.length,
				 u8arr = new Uint8Array(n);
				 while (n--) {
								u8arr[n] = bstr.charCodeAt(n);
				 }
				 return new File([u8arr], name, {
							 type: mime
					});
			},
			TakePhoto() {
					this.loading = true;
					let fileTypeName = (this.options.fileTypes.find(t=>t.value === this.formData.fileType)).label
					this.fileInfo.name = this.$page.format.customTime(new Date().getTime(),'YYYYMMDDHHmmss') + '.' + fileTypeName;
					this.fileInfo.path = this.formData.drive+this.formData.path + this.fileInfo.name 
					Cam_SetFileType(this.formData.fileType); //设置文件格式
					Cam_Photo(this.fileInfo.path);  //主摄像头拍照
			}
		}
	}
	
	function reFun(name,fn){
		window[name] = function(){
			console.log(name,arguments);
			fn.call(this,...arguments)
		} 
	}
</script>

<style scoped>

</style>